import { SUB_DOMAIN } from '@/constants/domain';
import { WEBVIEW_TYPE_ENTRY } from '@/constants/entry';
import { WEBVIEW_TYPE } from '@/stores/DeviceStore';

const ENTRY_BY_SUB_DOMAIN: Partial<Record<SUB_DOMAIN, WEBVIEW_TYPE_ENTRY>> = {
  [SUB_DOMAIN.KB_PAY]: WEBVIEW_TYPE_ENTRY.KB_PAY,
  [SUB_DOMAIN.TOSS]: WEBVIEW_TYPE_ENTRY.TOSS,
  [SUB_DOMAIN.KAKAOBANK]: WEBVIEW_TYPE_ENTRY.KAKAO_BANK,
};

const ENTRY_BY_WEBVIEW_TYPE: Partial<Record<WEBVIEW_TYPE, WEBVIEW_TYPE_ENTRY>> =
  {
    [WEBVIEW_TYPE.KB_PAY]: WEBVIEW_TYPE_ENTRY.KB_PAY,
    [WEBVIEW_TYPE.TOSS]: WEBVIEW_TYPE_ENTRY.TOSS,
  };

/**
 * `subDomain`을 먼저 본다 — 이 값만 SSR 초기값으로 존재하고 `webviewType`은 mount
 * effect 이후에 채워지므로, UA만 보면 서버 렌더가 전부 WELLO로 나가 제휴 화면에
 * 도달 불가한 링크와 잘못된 entry 질의가 새어나간다. UA는 딥링크 보강용이다.
 */
export const resolveWebviewEntry = (
  subDomain?: SUB_DOMAIN | null,
  webviewType?: WEBVIEW_TYPE,
): WEBVIEW_TYPE_ENTRY =>
  (subDomain ? ENTRY_BY_SUB_DOMAIN[subDomain] : undefined) ??
  (webviewType ? ENTRY_BY_WEBVIEW_TYPE[webviewType] : undefined) ??
  WEBVIEW_TYPE_ENTRY.WELLO;

const GA_USER_ENV_BY_PARTNER_ENTRY = {
  [WEBVIEW_TYPE_ENTRY.KB_PAY]: 'KB_PAY_APP',
  [WEBVIEW_TYPE_ENTRY.TOSS]: 'TOSS_APP',
  [WEBVIEW_TYPE_ENTRY.KAKAO_BANK]: 'KAKAOBANK_APP',
} as const;

export const resolveGaUserEnv = (
  subDomain?: SUB_DOMAIN | null,
  webviewType?: WEBVIEW_TYPE,
) => {
  const entry = resolveWebviewEntry(subDomain, webviewType);

  if (entry === WEBVIEW_TYPE_ENTRY.WELLO) {
    return webviewType === WEBVIEW_TYPE.WELLO_APP ? 'WELLO_APP' : 'WELLO_WEB';
  }

  return GA_USER_ENV_BY_PARTNER_ENTRY[entry];
};
